const diagram_store = {
    subscribers:{},
    diagram: undefined,
    getDiagram(){
        return this.diagram
    },
    setDiagram(diagram){
        this.diagram = diagram
    },
    setDamGateStatus(dam_id, gate_id, status){
        let dam = this.diagram.options.dams[dam_id]
        if(dam && dam.floodgates && dam.floodgates.gates){
            let gate = dam.floodgates.gates[gate_id]
            if(gate){
                gate.status = status
            }
        }
    },
    setDiagramNestedProp(path, value){
        _.set(this.diagram, path, value)
        this.publish('SET_DIAGRAM_NESTED_PROP', {path, value})
    },
    getDiagramNestedProp(path){
        return _.get(this.diagram, path, undefined)
    },
    diagramUpdated(){
        this.publish('DIAGRAM_UPDATED')
    },
    pathUpdatePosition(path){
        this.publish('PATH_UPDATE_POSITION', path)
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default diagram_store